import { sendServerRequest } from './baseService';

export const productService = {
    getProducts,
};

async function getProducts(meparCode) {
    return sendServerRequest('GET', `/api/products?meparCode=${meparCode}`);
}
